import React from 'react';
import { BrowserView, MobileView, useOrientation } from 'src/hooks/useDevice';
import ImgRotate from 'src/img/rotate.png';

const ResponsiveWrapper = ({ children }) => {
    const { isLandscape } = useOrientation();

    return (
        <>
            <BrowserView>
                {children}
            </BrowserView>

            <MobileView>
                {!isLandscape && <img src={ImgRotate} alt="Rotate device" />}
                {isLandscape && children}
            </MobileView>
        </>
    );
};

export default ResponsiveWrapper;
